<template>
  <div>
    <b-modal
      :id="id"
      modal-class="focus-modal"
      size="md"
      hide-footer
      hide-header
      centered
    >
      <!-- visible -->
      <span
        class="ico logo"
        v-b-tooltip.hover
        :title="journey"
        v-if="id == 'journey-focus'"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
            fill="var(--theme-color)"
          />
          <path
            d="M15.7171 15.7172C15.1872 15.7172 14.7364 16.0612 14.5755 16.5376H7.46188C6.76918 16.5376 6.20565 15.974 6.20565 15.2813C6.20565 14.5886 6.76918 14.0251 7.46188 14.0251H9.92307C11.0399 14.0251 11.9484 13.1165 11.9484 11.9998C11.9484 10.883 11.0399 9.9744 9.92307 9.9744H7.78314C7.66308 9.61891 7.38153 9.33736 7.02604 9.2173V8.28232H9.10267C9.31506 8.28232 9.48724 8.11014 9.48724 7.89776V6.25697C9.48724 6.04459 9.31506 5.87241 9.10267 5.87241H6.64148C6.4291 5.87241 6.25692 6.04459 6.25692 6.25697V7.89776V9.2173C5.78058 9.3782 5.43652 9.82901 5.43652 10.359C5.43652 11.0234 5.97706 11.5639 6.64148 11.5639C7.17143 11.5639 7.62224 11.2199 7.78314 10.7435H9.92307C10.6158 10.7435 11.1793 11.3071 11.1793 11.9998C11.1793 12.6925 10.6158 13.256 9.92307 13.256H7.46188C6.34509 13.256 5.43652 14.1646 5.43652 15.2813C5.43652 16.3981 6.34509 17.3067 7.46188 17.3067H14.5755C14.7364 17.783 15.1872 18.1271 15.7171 18.1271C16.3815 18.1271 16.9221 17.5866 16.9221 16.9221C16.9221 16.2577 16.3815 15.7172 15.7171 15.7172ZM7.02604 6.64153H8.71811V7.5132H7.02604V6.64153ZM6.64148 10.7948C6.40116 10.7948 6.20565 10.5993 6.20565 10.359C6.20565 10.1186 6.40116 9.92312 6.64148 9.92312C6.88181 9.92312 7.07732 10.1186 7.07732 10.359C7.07732 10.5993 6.88181 10.7948 6.64148 10.7948ZM15.7171 17.358C15.4768 17.358 15.2813 17.1625 15.2813 16.9221C15.2813 16.6818 15.4768 16.4863 15.7171 16.4863C15.9575 16.4863 16.153 16.6818 16.153 16.9221C16.153 17.1625 15.9575 17.358 15.7171 17.358Z"
            fill="white"
          />
          <path
            d="M15.7171 8.33356C15.0527 8.33356 14.5122 8.87408 14.5122 9.53849C14.5122 10.2029 15.0527 10.7434 15.7171 10.7434C16.3815 10.7434 16.9221 10.2029 16.9221 9.53849C16.9221 8.87408 16.3815 8.33356 15.7171 8.33356ZM15.7171 9.97432C15.4768 9.97432 15.2813 9.77881 15.2813 9.53849C15.2813 9.29817 15.4768 9.10266 15.7171 9.10266C15.9575 9.10266 16.153 9.29817 16.153 9.53849C16.153 9.77881 15.9575 9.97432 15.7171 9.97432Z"
            fill="white"
          />
          <path
            d="M15.7173 6.69278C14.1481 6.69278 12.8716 7.96934 12.8716 9.53847C12.8716 10.3858 13.2407 11.1752 13.8875 11.718L15.3747 14.6354C15.4403 14.7642 15.5727 14.8453 15.7173 14.8453C15.8619 14.8453 15.9942 14.7642 16.0599 14.6354L17.5471 11.718C18.1938 11.1752 18.563 10.3858 18.563 9.53847C18.563 7.96934 17.2864 6.69278 15.7173 6.69278ZM17.003 11.1693C16.9594 11.2037 16.9239 11.247 16.8987 11.2965L15.7173 13.614L14.5359 11.2965C14.5107 11.2471 14.4751 11.2037 14.4316 11.1693C13.9289 10.7724 13.6407 10.178 13.6407 9.53847C13.6407 8.39342 14.5722 7.46188 15.7173 7.46188C16.8623 7.46188 17.7938 8.39342 17.7938 9.53847C17.7938 10.178 17.5056 10.7724 17.003 11.1693Z"
            fill="white"
          />
        </svg>
      </span>
      <span class="close-icon ico" @click="$bvModal.hide(id)">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="10.6667"
                height="10.6667"
                fill="white"
                transform="translate(6.6665 6.66675)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>

      <h3>Create Focus</h3>

      <b-input-group class="mb-2">
        <b-input-group-prepend is-text>
          <label for="first">I shall</label>
        </b-input-group-prepend>
        <b-form-input
          id="first"
          v-model="iShall"
          aria-label="Text input with checkbox"
        ></b-form-input>
      </b-input-group>

      <div class="prefix-textarea">
        <span class="prefix">
          <label for="second">so that</label>
        </span>
        <textarea rows="2" v-model="soThat" id="second"></textarea>
      </div>

      <div class="add-desc">
        <h6
          class="d-inline"
          @click="show.description = true"
          v-if="description.trim() == ''"
          v-b-tooltip.hover
          title="Add Description"
        >
          Add description
        </h6>
        <h6
          class="d-inline"
          style="color: #474D52"
          v-else
          @click="show.description = true"
          v-b-tooltip.hover
          title="Edit Description"
        >
          {{ description }}
        </h6>
        <div
          class="overlay"
          v-if="show.description"
          @click="closeDescription"
        ></div>
        <div>
          <div class="desc" v-if="show.description == true">
            <textarea
              rows="7"
              v-model="tempDescription"
              placeholder="Add Description"
            ></textarea>
            <div class="foot-desc">
              <button class="btn-close" @click="closeDescription">Done</button>
            </div>
          </div>
        </div>
      </div>
      <div class="add-engines">
        <h6>
          Engines
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99984 15.4999C10.4601 15.4999 10.8332 15.1268 10.8332 14.6666C10.8332 14.2063 10.4601 13.8333 9.99984 13.8333C9.5396 13.8333 9.1665 14.2063 9.1665 14.6666C9.1665 15.1268 9.5396 15.4999 9.99984 15.4999Z"
              fill="#B3C2CB"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.2966 7.63313C9.89196 7.65089 9.67618 7.8137 9.60148 7.9724C9.4055 8.38882 8.90904 8.56752 8.49262 8.37153C8.0762 8.17555 7.8975 7.67909 8.09349 7.26267C8.52864 6.33808 9.46609 6.00131 10.2235 5.96806C10.9521 5.93609 11.8589 6.16816 12.3605 6.8223C12.7465 7.32567 12.9634 7.96376 12.8758 8.63468C12.787 9.31497 12.399 9.92521 11.7693 10.3884C10.9286 11.0069 10.93 11.3225 10.9303 11.3685C10.9303 11.3691 10.9303 11.3698 10.9303 11.3703C10.9303 11.8306 10.5572 12.2036 10.0969 12.2036C9.63669 12.2036 9.2636 11.8306 9.2636 11.3703C9.2636 10.5731 9.72733 9.82155 10.7817 9.04589C11.1058 8.80748 11.2022 8.57936 11.2231 8.41895C11.2453 8.24915 11.1972 8.04418 11.0379 7.83651C11.0267 7.8219 10.9659 7.76112 10.8135 7.70635C10.6679 7.65405 10.485 7.62486 10.2966 7.63313Z"
              fill="#B3C2CB"
            />
            <path
              d="M9.99992 19.6666C4.91658 19.6666 0.833252 15.5833 0.833252 10.4999C0.833252 5.41658 4.91658 1.33325 9.99992 1.33325C15.0833 1.33325 19.1666 5.41658 19.1666 10.4999C19.1666 15.5833 15.0833 19.6666 9.99992 19.6666ZM9.99992 2.99992C5.83325 2.99992 2.49992 6.33325 2.49992 10.4999C2.49992 14.6666 5.83325 17.9999 9.99992 17.9999C14.1666 17.9999 17.4999 14.6666 17.4999 10.4999C17.4999 6.33325 14.1666 2.99992 9.99992 2.99992Z"
              fill="#B3C2CB"
            />
          </svg>
        </h6>
        <div class="engine" v-for="(engine, n) in engines" :key="n">
          {{ engine.text }}
          <svg
            v-b-tooltip.hover
            title="Remove Engine"
            @click="removeEngine(n)"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L9 9"
              stroke="var(--theme-color)"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M9 1L1 9"
              stroke="var(--theme-color)"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <span
          class="ico"
          @click="show.engine = true"
          v-b-tooltip.hover
          title="Add Engines"
        >
          <svg
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="14"
              cy="14.5"
              r="14"
              fill="var(--theme-color)"
              fill-opacity="0.1"
            />
            <path
              d="M14 6.5V22.5"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M6 14.5L22 14.5"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <!-- start add engine -->
      </div>
      <!-- end add engine -->
      <div class="add-engines add-crew">
        <h6>
          Crew
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.99984 15.4999C10.4601 15.4999 10.8332 15.1268 10.8332 14.6666C10.8332 14.2063 10.4601 13.8333 9.99984 13.8333C9.5396 13.8333 9.1665 14.2063 9.1665 14.6666C9.1665 15.1268 9.5396 15.4999 9.99984 15.4999Z"
              fill="#B3C2CB"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.2966 7.63313C9.89196 7.65089 9.67618 7.8137 9.60148 7.9724C9.4055 8.38882 8.90904 8.56752 8.49262 8.37153C8.0762 8.17555 7.8975 7.67909 8.09349 7.26267C8.52864 6.33808 9.46609 6.00131 10.2235 5.96806C10.9521 5.93609 11.8589 6.16816 12.3605 6.8223C12.7465 7.32567 12.9634 7.96376 12.8758 8.63468C12.787 9.31497 12.399 9.92521 11.7693 10.3884C10.9286 11.0069 10.93 11.3225 10.9303 11.3685C10.9303 11.3691 10.9303 11.3698 10.9303 11.3703C10.9303 11.8306 10.5572 12.2036 10.0969 12.2036C9.63669 12.2036 9.2636 11.8306 9.2636 11.3703C9.2636 10.5731 9.72733 9.82155 10.7817 9.04589C11.1058 8.80748 11.2022 8.57936 11.2231 8.41895C11.2453 8.24915 11.1972 8.04418 11.0379 7.83651C11.0267 7.8219 10.9659 7.76112 10.8135 7.70635C10.6679 7.65405 10.485 7.62486 10.2966 7.63313Z"
              fill="#B3C2CB"
            />
            <path
              d="M9.99992 19.6666C4.91658 19.6666 0.833252 15.5833 0.833252 10.4999C0.833252 5.41658 4.91658 1.33325 9.99992 1.33325C15.0833 1.33325 19.1666 5.41658 19.1666 10.4999C19.1666 15.5833 15.0833 19.6666 9.99992 19.6666ZM9.99992 2.99992C5.83325 2.99992 2.49992 6.33325 2.49992 10.4999C2.49992 14.6666 5.83325 17.9999 9.99992 17.9999C14.1666 17.9999 17.4999 14.6666 17.4999 10.4999C17.4999 6.33325 14.1666 2.99992 9.99992 2.99992Z"
              fill="#B3C2CB"
            />
          </svg>
        </h6>
        <div
          class="engine"
          v-for="(crew, n) in crew"
          :key="n"
          @mouseenter="showCrewDetails(crew)"
          @mouseleave="hideCrewDetails"
        >
          {{ crew.nickname }}
          <svg
            v-b-tooltip.hover
            title="Remove Crew"
            @click="removeCrew(n)"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L9 9"
              stroke="var(--theme-color)"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M9 1L1 9"
              stroke="var(--theme-color)"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <span
          class="ico"
          @click="show.addCrew = true"
          v-b-tooltip.hover
          title="Add Crew"
        >
          <svg
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="14"
              cy="14.5"
              r="14"
              fill="var(--theme-color)"
              fill-opacity="0.1"
            />
            <path
              d="M14 6.5V22.5"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M6 14.5L22 14.5"
              stroke="var(--theme-color)"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </div>
      <div class="tools">
        <div>
          <h6>Tools:</h6>
          <div
            class="ico"
            @click="showTools"
            v-b-tooltip.hover
            title="Add Resources"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="14"
                cy="14"
                r="14"
                fill="var(--theme-color)"
                fill-opacity="0.1"
              />
              <path
                d="M14 6V22"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M6 14L22 14"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <img
            v-for="(tool, i) in tools"
            :src="tool.tooldetail ? tool.tooldetail.imgURL : ''"
            :key="i"
            :alt="tool.tooldetail ? tool.tooldetail.name : ''"
            v-b-tooltip.hover
            :title="tool.tooldetail ? tool.tooldetail.name : ''"
            v-show="i < 4"
            width="30"
          />
        </div>
        <div
          class="ico ico-more"
          v-if="tools.length > 4"
          @click="show.extraTools = !show.extraTools"
        >
          <svg
            width="30"
            height="6"
            viewBox="0 0 30 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="3" cy="3" r="3" fill="#D5D5D5" />
            <circle cx="15" cy="3" r="3" fill="#D5D5D5" />
            <circle cx="27" cy="3" r="3" fill="#D5D5D5" />
          </svg>
        </div>
        <div class="extra-tools" v-if="show.extraTools">
          <img
            v-for="(tool, i) in tools"
            :src="tool.tooldetail ? tool.tooldetail.imgURL : ''"
            :key="i"
            :alt="tool.tooldetail ? tool.tooldetail.name : ''"
            v-b-tooltip.hover
            :title="tool.tooldetail ? tool.tooldetail.name : ''"
            v-show="i >= 4 && i < 11"
            width="30"
          />
        </div>
      </div>
      <button
        class="create-btn"
        @click="createFocus"
        :disabled="iShall.trim() != '' && soThat.trim() != '' ? false : true"
      >
        <b-spinner v-if="processing" label="Spinning"></b-spinner>
        <span v-else>
          Create Focus
        </span>
      </button>
    </b-modal>
    <Tools @updateTools="updateTools($event)" />
    <Calendar
      v-if="show.calendar"
      @closeMe="show.calendar = false"
      @updateDate="dateTimeUpdated"
    />
    <Crew
      v-if="show.addCrew"
      @closeMe="updateCrews"
      :oldCrew="crew"
      :addedCrew="addedCrew"
    />
    <Engines
      v-if="show.engine"
      @closeMe="updateEngines"
      :oldEngines="engines"
      :addedEgines="addedEgines"
    />
  </div>
</template>

<script>
import Tools from "./tools";
import Crew from "./crew";
import Engines from "./engines";
import Calendar from "@/components/common/calendar/";

export default {
  props: ["id", "journey"],
  data() {
    return {
      processing: false,
      show: {
        timeSelector: false,
        description: false,
        engine: false,
        addCrew: false,
        calendar: false,
        extraTools: false,
        crewDetails: true
      },
      iShall: "",
      soThat: "",
      description: "",
      tempDescription: "",
      tools: [],
      activeCrew: {},
      crew: [],
      addedCrew: [],
      engines: [],
      addedEgines: []
    };
  },
  components: {
    Tools,
    Calendar,
    Crew,
    Engines
  },
  mounted() {
    this.$store.dispatch("user/getListNames");
    this.$store.dispatch("user/getListRoles");
    this.$store.dispatch("user/getListEngines");
  },
  computed: {
    valid() {
      this.description.trim() != "" &&
      this.tools.length != 0 &&
      this.crew.length != 0 &&
      this.engines.length != 0
        ? ""
        : true();
      return false;
    },
    compHours() {
      if (this.newEngine.hour < 10) {
        return "0" + this.newEngine.hour;
      }
      return this.newEngine.hour;
    },
    compMins() {
      if (this.newEngine.mins < 10) {
        return "0" + this.newEngine.mins;
      }
      return this.newEngine.mins;
    }
  },
  methods: {
    createFocus() {
      this.processing = true;

      let fullDestination = {
        text1: this.iShall,
        text2: this.soThat,
        detail: this.description
      };

      // cleaning up data toSave function
      let enginesToSave = [...this.engines];
      let namesToSave = [...this.crew];
      let toolsToSave = [
        ...this.tools.map(el => ({
          _created_at: el._created_at,
          uid: el.uid,
          text: el.text,
          subText: el.subText,
          tooldetail: el.tooldetail
        }))
      ];
      let toolsToSaveWOtext = [...toolsToSave];
      delete toolsToSaveWOtext.text;
      delete toolsToSaveWOtext.subText;

      this.$store
        .dispatch("user/addTools", {
          tools: toolsToSaveWOtext.length > 0 ? toolsToSaveWOtext : []
        })
        .then(toolswUid => {
          toolswUid.map((el, index) => {
            el.tools_id = el.uid;
            el.order = index;
            el.uid = el.text.toLowerCase().replace(" ", "") + el.uid;
            el.text = toolsToSave[index].text;
            el.subText = toolsToSave[index].subText;
            delete el.tooldetail;
            return el;
          });
          return this.$store
            .dispatch("user/addNames", {
              names: namesToSave.length > 0 ? namesToSave : []
            })
            .then(nameswUid => {
              nameswUid.map((el, index) => {
                el._names_numbers_places_id = el.uid;
                delete el.uid;
                el.order = index;
                return el;
              });
              return this.$store
                .dispatch("user/addAnEngines", {
                  engines: enginesToSave.length > 0 ? enginesToSave : []
                })
                .then(engineswUid => {
                  engineswUid.map((el, index) => {
                    el.engine_id = el.uid;
                    delete el.uid;
                    el.order = index;
                    el.focus_tool_ids = [];
                    return el;
                  });
                  return this.$store
                    .dispatch("user/addFocusedJourney", {
                      destination: fullDestination,
                      engines: engineswUid,
                      crew: nameswUid,
                      tools: toolswUid,
                      journey: this.journey
                        ? JSON.parse(JSON.stringify(this.journey))
                        : {}
                    })
                    .then(path => {
                      let roles = nameswUid.map(el => el.subText);
                      let filteredRoles = roles.filter(
                        (v, i, a) => a.indexOf(v) === i
                      );
                      let rolesToSave = filteredRoles.map(el => ({
                        _created_at: new Date(),
                        text: el
                      }));
                      return this.$store
                        .dispatch("user/addRoles", {
                          roles: rolesToSave
                        })
                        .then(() => {
                          this.processing = false;
                          this.$emit("focus-created", path);
                          this.$bvModal.hide("id");
                          console.log("Save process successsful");
                        });
                    });
                });
            });
        })
        .catch(error => {
          this.processing = false;
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    dateTimeUpdated(dateTime) {
      console.log(dateTime.date.format, dateTime.time);
      this.show.calendar = false;
    },
    showCrewDetails(crew) {
      this.show.crewDetails = true;
      this.activeCrew = crew;
    },
    hideCrewDetails() {
      this.show.crewDetails = false;
    },
    updateCrews(crew) {
      this.crew = crew.active;
      this.addedCrew = crew.all;
      this.show.addCrew = false;
    },
    removeCrew(n) {
      this.crew.splice(n, 1);
    },
    closeDescription() {
      this.show.description = false;
      this.description = this.tempDescription;
    },
    showTools() {
      this.$bvModal.show("tools");
    },
    updateEngines(engines) {
      console.log(engines);
      this.engines = engines.active;
      this.addedEgines = engines.all;
      this.show.engine = false;
    },
    removeEngine(index) {
      this.engines.splice(index, 1);
    },
    updateTools(tools) {
      this.tools = tools;
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  z-index: 500;
  cursor: pointer;
  position: absolute;
  margin-top: 15px;
}
.calendar {
  cursor: pointer;
}
.your-engine {
  .btn-close {
    svg {
      margin-left: 14px;
    }
  }
}
.foucs-guide {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  .focus-guide-body {
    padding: 16px;
  }
}
.modal-body {
  .close-icon {
    position: absolute;
    top: 32px;
    right: 32px;
    z-index: 2;
  }
  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 49px;
    text-align: center;
    color: #5b606c;
    position: relative;
    &::after {
      position: absolute;
      bottom: 0;
      border-bottom: 1px solid #ddd;
      content: "";
      width: 95%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .input-group-prepend {
    .input-group-text {
      background-color: #fff;
      border: none;
      padding-right: 0;
      font-style: normal;
      font-weight: 300;
      font-size: 28px;
      line-height: 38px;
      padding-left: 10px;
      color: #cbcbcb;
    }
  }
  select,
  textarea,
  textarea,
  .input-group input,
  .form-group input,
  .form-group input {
    font-style: normal;
    font-weight: 300;
    font-size: 28px;
    line-height: 38px;
    color: #5b606c;

    // color: #474d52;
    background: #ffffff;
    // border: 1px solid #dddddd;
    border: none;
    box-sizing: border-box;
    border-radius: 32px;
    height: 44px;
    &:focus {
      box-shadow: none;
    }
  }
  textarea {
    &::-webkit-scrollbar {
      width: 5px;
      margin-right: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #8d99a0;
      border-radius: 5px;
    }
  }
  .ico {
    cursor: pointer;
  }
  .prefix-textarea {
    position: relative;

    span.prefix {
      font-style: normal;
      font-weight: 300;
      font-size: 28px;
      line-height: 38px;
      padding-left: 10px;
      color: #cbcbcb;
      position: absolute;
    }
    textarea {
      border-radius: 0;
      width: 100%;
      height: unset;
      text-indent: 100px;
      resize: none;
      color: #5b606c;
    }
  }
  .btn-close {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    color: var(--theme-color);
    background-color: #fff;
    border: none;
  }
  .add-desc {
    margin-bottom: 12px;
    // display: grid;
    // grid-template-columns: 50px 1fr 35px;
    align-items: center;
    // position: relative;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 27px;
      color: #cbcbcb;
      margin: 0;
    }
    h6,
    .emoji.ico {
      cursor: pointer;
    }
    .overlay {
      position: fixed;
      z-index: 1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.25);
    }
    .desc {
      position: absolute;
      top: 180px;
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
      height: 240px;
      z-index: 2;
      background-color: #fff;
      box-shadow: 2px 2px 40px rgba(33, 24, 86, 0.05);
      border-radius: 5px;
      padding: 10px;
      textarea {
        z-index: 1;
        height: 186px;
        width: 100%;
        resize: none;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        color: #474d52;
        border-radius: 0;
        &::-webkit-input-placeholder {
          /* Edge */
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 25px;
          /* identical to box height */

          color: #cbcbcb;
        }

        &:-ms-input-placeholder {
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 25px;
          /* identical to box height */

          color: #cbcbcb;
        }

        &::placeholder {
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 25px;
          /* identical to box height */

          color: #cbcbcb;
        }
      }
      .foot-desc {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  .add-crew,
  .add-engines {
    margin-top: 32px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .engine {
      margin-top: 3px;
      background-color: rgba(85, 126, 251, 0.1);
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      display: flex;
      align-items: center;
      color: var(--theme-color);
      margin-right: 7px;
      svg {
        margin-left: 5px;
        cursor: pointer;
      }
    }

    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      display: inline;
      color: #5b606c;
      margin-right: 10px;
      //   margin-bottom: 0;
    }
  }
  .add-crew {
    position: relative;
    .crew-form {
      position: absolute;
      right: 0;
      top: 0;
      // transform: translateY(-50%);
      width: 252px;
      // height: 130px;
      padding: 15px;
      background: #ffffff;
      box-shadow: 2px 2px 40px rgba(33, 24, 86, 0.05);
      border-radius: 5px;
      .form-input {
        display: grid;
        grid-template-columns: 50px 1fr;
        align-items: center;
        label {
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          color: #cbcbcb;
        }
        h4 {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          /* identical to box height */

          color: #5b606c;
        }
      }
      .send {
        cursor: pointer;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;

        color: var(--theme-color);
      }
    }
  }
  .add-engines {
    position: relative;
    .your-engine {
      z-index: 2;
      padding: 15px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      //   height: 337px;
      box-shadow: 2px 2px 40px rgba(33, 24, 86, 0.09);
      border-radius: 5px;
      background-color: #fff;
      .title {
        position: relative;
        .icon {
          position: absolute;
          left: 10px;
          top: 0px;
          cursor: pointer;
        }
        h4 {
          text-align: center;
          // display: inline;
          font-style: normal;
          font-weight: normal;
          font-size: 24px;
          line-height: 33px;
          /* identical to box height */

          text-align: center;

          color: #5b606c;
        }
      }
      p {
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 22px;
        /* identical to box height */
        text-align: center;
        color: #9b9b9b;
      }
      .new-engines {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h4 {
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #474d52;
        }
        .right {
          display: flex;
          justify-content: center;
          h5 {
            font-family: "Nunito", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 22px;
            text-align: right;
            color: #8d99a0;
          }
          .ico {
            margin-left: 20px;
          }
        }
      }
      textarea {
        font-family: Nunito;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 22px;
        /* identical to box height */
        width: 100%;
        resize: none;
        color: #5b606c;
      }
      .selections {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
        .time {
          background-color: #f3f6f9;
          width: 108px;
          border-radius: 10px;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          text-align: center;
          height: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #5b606c;
          position: relative;
          transition: all 0.2s ease-in-out;
          &:hover,
          &:active {
            background: var(--theme-color);
            color: #fff;
            fill: #fff !important;
          }
          & > span {
            cursor: pointer;
            width: 100%;
            display: flex;
            justify-content: space-evenly;
            // align-items: center;
            align-items: center;
          }
          .time-selector {
            position: absolute;
            top: 100%;
            left: 0%;
            background-color: #fff;
            box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
            border-radius: 8px;
            padding: 8px;
            * {
              user-select: none; /* standard syntax */
              -webkit-user-select: none; /* webkit (safari, chrome) browsers */
              -moz-user-select: none; /* mozilla browsers */
              -khtml-user-select: none; /* webkit (konqueror) browsers */
              -ms-user-select: none; /* IE10+ */
            }
            .time-input {
              // input {
              background: #ffffff;
              border-radius: 32px;
              border: 1px solid #ddd;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 7px;
              margin: 4px 0;
              h5 {
                font-family: "Nunito", sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                color: #474d52;
                margin: 0;
              }
              // }
            }
            .select__time {
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .wraper__time {
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              border: 1px solid #dddddd;
              box-sizing: border-box;
              border-radius: 4px;
              margin: 0px 3px;
              span {
                height: 30px;
                width: 45px;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                &.ico-up {
                  &:after {
                    content: "";
                    width: 90%;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 0;
                    position: absolute;
                    border-bottom: 1px solid #dddddd;
                  }
                }
                &.ico-down {
                  &:after {
                    content: "";
                    width: 90%;
                    left: 50%;
                    transform: translateX(-50%);
                    top: 0;
                    position: absolute;
                    border-bottom: 1px solid #dddddd;
                  }
                }
                &.time-digit {
                  height: 33px;
                  input {
                    border: none;
                    text-align: center;
                    &:focus {
                      outline: none;
                    }
                  }
                  input::-webkit-outer-spin-button,
                  input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                  }

                  /* Firefox */
                  input[type="number"] {
                    -moz-appearance: textfield;
                  }
                }
              }
            }
          }
        }
        .days {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .day,
          .now {
            width: 50px;
            height: 24px;
            background: #f3f6f9;
            border-radius: 1000px;
            font-style: normal;
            font-weight: 300;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #8d99a0;
            cursor: pointer;
            margin: 0 2px;
            transition: all 0.2s ease-in-out;
            &:hover,
            &.active {
              background: var(--theme-color);
              color: #fff;
            }
          }
          .day {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
        }
      }
    }
    .add-engine {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 50px 0 15px 0;
    }
  }
  .tools {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #eceff9;
    border-radius: 8px;
    padding: 12px 20px;
    position: relative;
    .extra-tools {
      position: absolute;
      top: 100%;
      width: 100%;
      left: 0;
      background-color: #fff;
      border: 1px solid #eceff9;
      border-top: 0;
      padding: 0px 11px 11px 11px;
      display: flex;
      justify-content: center;
    }
    .ico,
    img {
      margin: 0 17px;
    }
    .ico-more {
      margin: 0;
    }
    & > div {
      flex-wrap: wrap;
      display: flex;
      align-items: center;
      h6 {
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 33px;
        color: #5b606c;
        margin: 0 10px 0 0;
      }
    }
  }
  .create-btn {
    margin-top: 55px;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    border-radius: 8px;
    width: 100%;
    height: 50px;
    color: #ffffff;
    background-color: var(--theme-color);
    border: 1px solid var(--theme-color);

    &:disabled,
    &[disabled] {
      color: #bdc1c5;
      border: 1px solid #eceff9;
      background: #eceff9;
    }
  }
}
</style>
